import { addOrUpdateChatHandler } from '../../apiClient';
import { notifications } from '@mantine/notifications';
import { useEntityQueryUpdate } from '../../../hooks/useEntityQueryUpdate';
import { useMutation } from '@tanstack/react-query';

const useAddChatHandler = () => {
    const entityUpdater = useEntityQueryUpdate();

    const mutation = useMutation({
        mutationKey: 'add_chat_handler',
        mutationFn: (model) => addOrUpdateChatHandler(model),
        onSuccess: (data) => {
            entityUpdater([['chat_handlers'], ['chat_handler', data.id]], data);
            notifications.show({
                title: 'Success',
                message: 'Successfully updated chat handler',
                color: 'green',
            });
        },
        onError: (error) => {
            notifications.show({
                title: 'Error',
                message: error.message,
                color: 'red',
            });
        },
    });
    return mutation;
};
export default useAddChatHandler;
